import styles from "./SettingButton.module.css";
import Setting from "@/assets/icons/common/setting.svg?react";
import ArrowSetting from "@/assets/icons/common/arrow-setting.svg?react";
import { observer } from "mobx-react-lite";
import { userStore } from "@/stores/UserStore";
import { userPanelSettingStore } from "@/stores/UserPanelSettingStore";

export const SettingButton = observer(() => {
  const { login } = userStore;
  const { modal } = userPanelSettingStore;
  const { roleName } = userStore;

  return (
    <button className={styles.button} onClick={() => modal.isOpen()}>
      <Setting />
      <div className={styles.divButtonUser}>
        <span>{login}</span>
        <p>{roleName}</p>
      </div>
      <ArrowSetting />
    </button>
  );
});
